import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const certificateExpiredTemplates = [
  {
    id: '-132001',
    language: Language.EN,
    subject: 'Certificate expired',
    type: TemplateType.MAIL,
    subType: TemplateSubType.CERTIFICATE_EXPIRED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{getContactName contact}},</p>
        <p></p>
        <p>This is to inform you that the certificate <b>{{certificateName}}</b> has expired for the following properties:</p>
        {{getBuildingNames buildings}}
        <p>Please take the necessary steps to renew it as soon as possible.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-132002',
    language: Language.FR,
    subject: 'Certificat expiré',
    type: TemplateType.MAIL,
    subType: TemplateSubType.CERTIFICATE_EXPIRED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher {{getContactName contact}},</p>
        <p></p>
        <p>Nous vous informons que le certificat <b>{{certificateName}}</b> a expiré pour les biens suivants :</p>
        {{getBuildingNames buildings}}
        <p></p>
        <p>Veuillez prendre les mesures nécessaires pour le renouveler dans les plus brefs délais.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-132003',
    language: Language.NL,
    subject: 'Certificaat verlopen',
    type: TemplateType.MAIL,
    subType: TemplateSubType.CERTIFICATE_EXPIRED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{getContactName contact}},</p>
        <p></p>
        <p>Wij informeren u dat het certificaat <b>{{certificateName}}</b> is verlopen voor de volgende panden:</p>
        {{getBuildingNames buildings}}
        <p></p>
        <p>Gelieve de nodige stappen te ondernemen om het zo snel mogelijk te vernieuwen.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-132004',
    language: Language.DE,
    subject: 'Zertifikat abgelaufen',
    type: TemplateType.MAIL,
    subType: TemplateSubType.CERTIFICATE_EXPIRED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{getContactName contact}},</p>
        <p></p>
        <p>Wir möchten Sie darüber informieren, dass das Zertifikat <b>{{certificateName}}</b> für die folgenden Immobilien abgelaufen ist:</p>
        {{getBuildingNames buildings}}
        <p></p>
        <p>Bitte ergreifen Sie die notwendigen Maßnahmen, um es so schnell wie möglich zu erneuern.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
